import { useTranslation } from "react-i18next";

import type { SensorIcon } from "@map/logic";

import { OccupancyStatusIcon } from "./OccupancyStatusIcon";

type AreaBusynessIconProps = {
  status: SensorIcon;
};

export const AreaBusynessIcon = ({ status }: AreaBusynessIconProps) => {
  const { t } = useTranslation();

  const labels: Record<SensorIcon, string> = {
    full: t("translation:Full"),
    busy: t("translation:Busy"),
    lively: t("translation:Lively"),
    quiet: t("translation:Quiet"),
    unknown: t("translation:NoSensorData"),
  };

  return (
    <>
      <OccupancyStatusIcon status={status} />
      <span className="sr-only">{labels[status]}</span>
    </>
  );
};
